const userAction = {
	/**
	 * 获取教师信息
	 */
	GET_TEA_INFO: 'INIT_TEA_INFO',
	/**
	 * 更新教师信息
	 */
	UPDATE_TEA_INFO: 'UPDATE_TEA_INFO',
	/**
	 * 重置所有状态
	 */
	RESET_USER_STORE: 'RESET_USER_STORE'
}

export default userAction
